import React from "react";

const SettlementStats = ({ stats }) => {

    const cards = [

        {
            title: "Total Paid",
            value: `₹${stats.totalPaid || 0}`,
        },

        {
            title: "Pending",
            value: `₹${stats.pending || 0}`,
        },

        {
            title: "Processing",
            value: `₹${stats.processing || 0}`,
        },

        {
            title: "Failed",
            value: `₹${stats.failed || 0}`,
        },

    ];

    return (

        <div className="settlement-stats">

            {

                cards.map(card => (

                    <div
                        key={card.title}
                        className="settlement-card"
                    >

                        <h4>{card.title}</h4>

                        <h2>{card.value}</h2>

                    </div>

                ))

            }

        </div>

    );

};

export default SettlementStats;